import { showError, showToast } from "../constants/toasts";

export const updateStatus = async (
  id: string,
  status: boolean,
  updateStatusMutation: any,
  setData: any,
  data: any,
  body: any
) => {
  const response = await updateStatusMutation({
    id,
    body,
  }).unwrap();

  if (response?.statusCode === 200) {
    const updatedData = data.map((x: any) => {
      if (x._id === id) {
        return {
          ...x,
          isBlocked: status,
        };
      }
      return x;
    });
    setData(updatedData);
    if (!status) {
      showToast("Enabled successfully");
    } else {
      showToast("Disabled successfully");
    }
  } else {
    showError("Please try again");
  }
};

export function getEmbedUrl(link: string) {
  try {
    const url = new URL(link);

    if (
      url.hostname.includes("youtube.com") ||
      url.hostname.includes("youtu.be")
    ) {
      let videoId;
      if (url.hostname === "youtu.be") {
        videoId = url.pathname.slice(1);
      } else {
        videoId = url.searchParams.get("v");
      }
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Add more providers as needed (e.g., Vimeo, etc.)
    // Example for Vimeo:
    if (url.hostname.includes("vimeo.com")) {
      const videoId = url.pathname.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}`;
    }

    // Default: return the same link if no specific handling
    return link;
  } catch (e) {
    console.error("Invalid URL:", link);
    return "";
  }
}

export const isQuillEmpty = (value: any) => {
  if (!value) return true;

  const clean = value
    .replace(/<[^>]*>/g, "") // ✅ safe regex
    .trim();

  return clean.length === 0;
};
export const formatDuration = (totalHours: number) => {
  if (!totalHours) return "-";

  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  const parts = [];
  if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
  if (hours > 0) parts.push(`${hours} hr${hours > 1 ? "s" : ""}`);

  return parts.length > 0 ? parts.join(" ") : "-";
};
